import axios from "axios";
import React, { useEffect } from "react";
import ProgressBar from "../../../redesign/atoms/ProgressBar";
import CategoryBadge from "../../../redesign/CategoryBadge";
import {
  h3,
  bodyLarge,
  bodyLargeStrong,
} from "../../../redesign/commonStyles/Fonts";
import { styled } from "../../../stitches.config";
import { useStores, pushDataLayer } from "../../../helpers"


const getAnswer = (index) => {
  switch (index) {
    case 0:
      return "a";
    case 1:
      return "b";
    case 2:
      return "c";
    case 3:
      return "d";
    case 4:
      return "e";
    default:
      return "";
  }
};

const PollWrapper = ({ data }) => {
  const { questions } = data;
  return questions.map((data) => <Poll data={data} />);
};

const Poll = ({ data }) => {
  const [selectedOption, setSelectedOption] = React.useState(null);
  const [totalResults, setTotalResults] = React.useState(data.results.totalVotes);
  const [results, setResults] = React.useState(data.results.votes);
  const [isVoted, setVoted] = React.useState(false);
  const [percentValues, setPercentValues] = React.useState(data.results.percentages);
  const { ArticleStore } = useStores();

  useEffect(() => {
    const pollVoted = JSON.parse(localStorage.getItem("pollVoted")) || [];
    if (pollVoted.length && results) {
      if (pollVoted.includes(data.id)) setVoted(true);
    }
  }, [results]);

  const onChangeRadio = (e, index) => {
    const pollVoted = JSON.parse(localStorage.getItem("pollVoted")) || [];

    axios
      .post(
        `${window.API_HOST}/pwa-poll-vote?answer[${data.id}]=${getAnswer(index)}&article=${ArticleStore.article.OID}`
      )
      .then((results) => {
        setSelectedOption(e.target.value);

        setTotalResults(results.data.results[data.id].totalVotes);
        setPercentValues(results.data.results[data.id].percentages);
        setResults(results.data.results[data.id].votes);

        localStorage.setItem(
          "pollVoted",
          JSON.stringify([...pollVoted, data.id])
        );
      });
  };

  // adding virtual page view
  const dataLayerObject = {
    'event': 'virtualPageview',
    'virtualPageURL': ArticleStore.article.uri,
    'virtualPageTitle': ArticleStore.article.seo_title,
    'pageType': 'Artykuł z Sondą',
  }

  return (

    <Wrapper>
      <CategoryBadge text="Sonda" />
      <h3 className={h3()}>{data.title}</h3>
      <Stats className={bodyLarge()}>{totalResults} odpowiedzi</Stats>
      <Image src={data.url} />
      {data.poll.map(
        ({ option }, index) =>
          option && (
            <>
              {selectedOption || isVoted ? (
                <Option type="progress" key={`pollAnswer_${getAnswer(index)}`}>
                  <label
                    className={bodyLarge()}
                    htmlFor={option}
                    style={{ position: "absolute" }}
                  >
                    {option}
                  </label>
                  <ProgressBar percent={percentValues?.[getAnswer(index)] ?? 0} />
                  <ProgressLabel className={bodyLargeStrong()}>
                    {percentValues?.[getAnswer(index)] ?? 0}%
                  </ProgressLabel>
                </Option>
              ) : (
                <Option key={`pollAnswer_${getAnswer(index)}`}>
                  <input
                    type="radio"
                    id={option}
                    value={option}
                    checked={selectedOption === option}
                    onChange={(e) => onChangeRadio(e, index)}
                    onClick={() => pushDataLayer(dataLayerObject)}
                  />
                  <label className={bodyLarge()} htmlFor={option}>
                    {option}
                  </label>
                </Option>
              )}
            </>
          )
      )}
    </Wrapper>
  );
};

const Wrapper = styled("div", {
  padding: "24px 16px",
  background: "$grayscale0",
  position: "relative",
  zIndex: "1000",

  h3: {
    margin: "16px 0",
  },

  "@bp4": {
    padding: "32px",
  },
});

const ProgressLabel = styled("span", {
  position: "absolute",
  top: "50%",
  right: "16px",
  transform: "translateY(-50%)",
});

const Option = styled("div", {
  border: "1px solid $grayscale25",
  height: "48px",
  padding: "12px",
  marginBottom: "16px",
  display: "flex",
  alignItems: "center",

  variants: {
    type: {
      progress: {
        padding: 0,
        position: "relative",
      },
    },
  },

  label: {
    padding: "12px 0",
    paddingLeft: "16px",
    display: "inline-block",
    width: "100%",
    cursor: "pointer",
  },

  "input[type='radio']:after": {
    width: "15px",
    height: "15px",
    borderRadius: "15px",
    top: "0",
    left: "-1px",
    position: "relative",
    backgroundColor: "$grayscale0",
    content: "",
    visibility: "visible",
    border: "1px solid $grayscale25",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  "input[type='radio']:checked:after": {
    width: "15px",
    height: "15px",
    borderRadius: "15px",
    top: "0",
    left: "-1px",
    position: "relative",
    backgroundColor: "$natematPrimary",
    content: "✓",
    color: "$grayscale0",
    visibility: "visible",
    border: "1px solid $grayscale25",
    fontSize: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});

const Stats = styled("p", {
  color: "$grayscale75",
});

const Image = styled("img", {
  maxWidth: "100%",
  marginBottom: "16px",
});

export default PollWrapper;
